import "./Cards.css"

const Cards = (props) => {
    return(
      <section className="summary-grid">
        
        {props.children}

      </section>
    );
};

export default Cards;